"use client";

import { c as _c } from "react/compiler-runtime";
import type { CicStatement } from "@/entities/IProfile";
import { useState } from "react";
import PencilIcon from "@/components/utils/icons/PencilIcon";
import UserPageHeaderAboutStatement from "./UserPageHeaderAboutStatement";
import UserPageHeaderAboutEdit from "./UserPageHeaderAboutEdit";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
enum AboutStatementView {
  STATEMENT = "STATEMENT",
  EDIT = "EDIT",
}
function UserPageHeaderAboutContent(t0) {
  const $ = _c(17);
  const {
    profile,
    statement,
    canEdit
  } = t0;
  const [view, setView] = useState(AboutStatementView.STATEMENT);
  let t1;
  if ($[0] !== view) {
    t1 = () => {
      if (view === AboutStatementView.STATEMENT) {
        setView(AboutStatementView.EDIT);
      } else {
        setView(AboutStatementView.STATEMENT);
      }
    };
    $[0] = view;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleView = t1;
  let t2;
  if ($[2] !== toggleView || $[3] !== view) {
    t2 = () => {
      if (view === AboutStatementView.STATEMENT) {
        toggleView();
      }
    };
    $[2] = toggleView;
    $[3] = view;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onEditClick = t2;
  let t3;
  if ($[5] !== canEdit || $[6] !== onEditClick || $[7] !== statement || $[8] !== view) {
    t3 = view === AboutStatementView.STATEMENT && <div className="tw-max-w-3xl"><div className={["tw-inline-flex tw-items-start tw-gap-2", canEdit ? "tw-group" : ""].filter(Boolean).join(" ")}>{canEdit ? <button type="button" onClick={onEditClick} aria-label={statement ? "Edit About statement" : "Add About statement"} className="tw-flex-1 tw-border-none tw-bg-transparent tw-p-0 tw-text-left"><UserPageHeaderAboutStatement statement={statement} /></button> : <UserPageHeaderAboutStatement statement={statement} />}{canEdit && <button type="button" onClick={onEditClick} aria-label={statement ? "Edit About statement" : "Add About statement"} className="tw-pointer-events-none tw-shrink-0 tw-border-none tw-bg-transparent tw-p-0 tw-text-iron-400 tw-opacity-0 tw-transition tw-duration-200 group-focus-within:tw-pointer-events-auto group-focus-within:tw-opacity-100 group-hover:tw-pointer-events-auto group-hover:tw-opacity-100 hover:tw-text-iron-200"><PencilIcon /></button>}</div></div>;
    $[5] = canEdit;
    $[6] = onEditClick;
    $[7] = statement;
    $[8] = view;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== profile || $[11] !== statement || $[12] !== view) {
    t4 = view === AboutStatementView.EDIT && <div><UserPageHeaderAboutEdit profile={profile} statement={statement} onClose={() => setView(AboutStatementView.STATEMENT)} /></div>;
    $[10] = profile;
    $[11] = statement;
    $[12] = view;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export default function UserPageHeaderAbout(t0) {
  const $ = _c(12);
  const {
    profile,
    statement,
    canEdit
  } = t0;
  const t1 = statement?.id;
  const t2 = statement?.statement_value;
  const t3 = canEdit ? "editable" : "readonly";
  let t4;
  if ($[0] !== profile.handle || $[1] !== profile.id || $[2] !== profile.query || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = [profile.id, profile.handle, profile.query, t1, t2, t3].map(_temp);
    $[0] = profile.handle;
    $[1] = profile.id;
    $[2] = profile.query;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const resetKey = t4.join(":");
  let t5;
  if ($[7] !== canEdit || $[8] !== profile || $[9] !== resetKey || $[10] !== statement) {
    t5 = <div id="profile-about" className="tw-scroll-mt-24"><UserPageHeaderAboutContent key={resetKey} profile={profile} statement={statement} canEdit={canEdit} /></div>;
    $[7] = canEdit;
    $[8] = profile;
    $[9] = resetKey;
    $[10] = statement;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(value) {
  return `${value ?? ""}`;
}